import React from "react";
import { Box, FormGroup, FormLabel } from "@mui/material";
import { UserBalanceProps, UserBalanceState } from "./interface";
import UserDetailsService from "../../../Services/UserDetailsService";

class UserBalance extends React.Component<UserBalanceProps, UserBalanceState> {
    constructor(props: UserBalanceProps) {
        super(props);
        this.state = {
            totalWalletBalance: '0.00',
            couponAmount: '0.00',
            walletAmount: '0.00',
            currencySymbol: '',
        };
    }

    componentDidMount(): void {
        this.getUserBalance();
    }

    private getUserBalance() {
        UserDetailsService.getUserBalance(this.props.userId, this.props.accessToken)
            .then((res: any) => {
                if (res.ok) {
                    res.json().then((resp: any) => {
                        this.setState({
                            totalWalletBalance: resp.totalAmount ?? '0.00',
                            walletAmount: resp.walletAmount ?? '0.00',
                            couponAmount: resp.couponAmount ?? '0.00',
                            currencySymbol: resp.currencySymbol ?? '',
                        });
                    });
                } else {
                    throw new Error('Failed to data');
                }
            })
    }


    render() {
        const { totalWalletBalance, couponAmount, walletAmount, currencySymbol } = this.state;
        const symbol = currencySymbol || '';

        return (
            <FormGroup>
                <Box style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <fieldset className="fieldset-border">
                        <FormLabel>User Balance</FormLabel>
                        <Box style={{ display: 'flex', gap: '20px' }}>

                            <Box style={{ flex: 1, marginTop: 23 }}>
                                <FormGroup>
                                    <FormLabel>Voucher: </FormLabel>

                                    <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                                        <FormLabel className='input-field-label'>{`${symbol} ${couponAmount}`}</FormLabel>
                                    </Box>
                                </FormGroup>
                            </Box>

                            <Box style={{ flex: 1, marginTop: 23 }}>
                                <FormGroup>
                                    <FormLabel>Wallet: </FormLabel>

                                    <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                                        <FormLabel className='input-field-label'>{`${symbol} ${walletAmount}`}</FormLabel>
                                    </Box>
                                </FormGroup>
                            </Box>

                            <Box style={{ flex: 1, marginTop: 23 }}>
                                <FormGroup>
                                    <FormLabel> <b>Total Balance: </b></FormLabel>

                                    <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                                        <FormLabel className='input-field-label'> <b>{`${symbol} ${totalWalletBalance}`}</b> </FormLabel>
                                    </Box>
                                </FormGroup>
                            </Box>

                        </Box>
                    </fieldset>
                </Box>
            </FormGroup>
        );
    }
}

export default UserBalance;